export var OrderStatusType;
(function (OrderStatusType) {
    OrderStatusType[OrderStatusType["UNPAID"] = 0] = "UNPAID";
    OrderStatusType[OrderStatusType["WIN"] = 1] = "WIN";
    OrderStatusType[OrderStatusType["LOSE"] = 2] = "LOSE";
    OrderStatusType[OrderStatusType["CANCELED"] = 3] = "CANCELED";
    OrderStatusType[OrderStatusType["CANCELED_BY_SYSTEM"] = 4] = "CANCELED_BY_SYSTEM";
    OrderStatusType[OrderStatusType["TIE"] = 5] = "TIE"; // 平手
})(OrderStatusType || (OrderStatusType = {}));
//# sourceMappingURL=OrderStatusType.js.map